<ng-template #showOnlyCurrentSwitch>
    <app-switch-input
        [formField]="formDef.showOnlyCurrent"
        [label]="prefix + 'showOnlyCurrent'"
        class="my-2"
    ></app-switch-input>
</ng-template>

<app-table
    #table
    [tableKey]="'microsoftGraphKeysSettings'"
    [subtitle]="showOnlyCurrentSwitch"
    [gridData]="store.data.getMicrosoftGraphKeysSettings()"
    [columns]="columns"
    [translatePrefix]="prefix"
    [tableTitle]="prefix + 'tableTitle'"
    [hideCheckboxes]="true"
    (createCallback)="openDetail()"
    (detailCallback)="openDetail($event)"
    (deleteCallbackWithEvent)="deleteItem($event)"
    [refreshCallback]="store.api.getMicrosoftGraphKeysSettings"
    [additionalFilter]="filters()"
></app-table>
